// extracted by mini-css-extract-plugin
export default {"layoutGridOuter":"layoutGridOuter-wXvA8","layoutGrid":"layoutGrid-flAG8","flexible":"flexible-hogwk","multiToOneColMobile":"multiToOneColMobile-r2JSO"};